import React, { createContext, useContext, useState, ReactNode } from "react";
import { TruckDetailListing } from "../../models/TruckDetailListing";
interface wrapperProviderProps {
  children: ReactNode;
}

interface WrapperContextType {
  prevRecord: object;
  setPrevRecord: (prevRecord: object) => void;
}

const WrapperContext = createContext<WrapperContextType | undefined>(undefined);

export const useWrapperContext = (): WrapperContextType => {
  const context = useContext(WrapperContext);
  if (!context) {
    throw new Error(
      "useWrapperContext must be used within a truckDetailProvider"
    );
  }
  return context;
};

export const WrapperProvider: React.FC<wrapperProviderProps> = ({
  children,
}) => {
  const [prevRecord, setPrevRecord] = useState({});

  return (
    <WrapperContext.Provider
      value={{
        prevRecord,
        setPrevRecord,
      }}
    >
      {children}
    </WrapperContext.Provider>
  );
};
